import { useTranslation } from 'react-i18next';

export default function ChatSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl overflow-hidden shadow-2xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div className="p-8 lg:p-12">
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-lg mb-6">
                <i className="ri-customer-service-2-line text-4xl text-white"></i>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {t('chat_title')}
              </h2>
              <p className="text-base text-teal-50 mb-6 leading-relaxed">
                {t('chat_subtitle')}
              </p>
              <p className="text-sm text-teal-100 mb-8 leading-relaxed">
                {t('chat_description')}
              </p>
              <a
                href="https://www.instagram.com/medivoyage_uz/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-3 bg-white text-teal-600 text-base font-medium rounded-md hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
              >
                {t('chat_cta')}
              </a>
            </div>

            {/* Right Image */}
            <div className="relative h-96 lg:h-full">
              <img
                src="https://public.readdy.ai/ai/img_res/acbb792471d24424eac82068695bbe4c.jpg"
                alt="Medical Consultation"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}